// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_xLG","cls2":"ArticlesFilters-cls2_GpJ ArticlesFilters-cls1_xLG"};